/**
 * Bong tuyet roi — chi bat o nhom trang Santa Spins (layout/theme.liquid quyet
 * dinh qua snippets/la-santa.liquid), khong o trang ao nguc.
 *
 * Bon dieu bat buoc, khong phai tuy chon:
 *   1. pointer-events: none — tuyet nam TREN noi dung, khong duoc nuot cu bam
 *      vao nut mua.
 *   2. Ton trong prefers-reduced-motion: nguoi bat la vi chong mat / dong kinh.
 *   3. Dung khi tab an (visibilitychange) — chay ngam chi ton pin.
 *   4. It bong (36 tren dien thoai, 60 tren may tinh), ve bang canvas: hang tram
 *      phan tu DOM dong thoi la giat tren may yeu, dung tep khach 4G.
 *
 * Mau: bong TRANG co vien mo xam-xanh. Trang tron thi bien mat tren nen trang
 * cua cac khoi duoi (do 15/10/2026 — cac khoi ba buoc, FAQ deu nen trang).
 */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const c = document.createElement('canvas');
  c.className = 'tuyet';
  c.setAttribute('aria-hidden', 'true');
  document.body.appendChild(c);
  const g = c.getContext('2d');

  let w = 0, h = 0, dpr = 1, bong = [], chay = true, hen = 0;
  const so = () => (innerWidth < 750 ? 36 : 60);

  const tao = (dau) => ({
    x: Math.random() * w,
    y: dau ? Math.random() * h : -10,
    r: 1.5 + Math.random() * 2.8,
    vy: 0.35 + Math.random() * 0.9,
    lac: Math.random() * Math.PI * 2,
    bien: 0.4 + Math.random() * 0.9,
    a: 0.55 + Math.random() * 0.4,
  });

  const doiCo = () => {
    dpr = Math.min(devicePixelRatio || 1, 2);
    w = innerWidth; h = innerHeight;
    c.width = w * dpr; c.height = h * dpr;
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    const n = so();
    while (bong.length < n) bong.push(tao(true));
    bong.length = n;
  };

  const ve = () => {
    g.clearRect(0, 0, w, h);
    for (const b of bong) {
      b.lac += 0.012;
      b.x += Math.sin(b.lac) * b.bien * 0.35;
      b.y += b.vy;
      if (b.y > h + 10 || b.x < -10 || b.x > w + 10) Object.assign(b, tao(false));
      g.beginPath();
      g.arc(b.x, b.y, b.r, 0, Math.PI * 2);
      g.fillStyle = `rgba(255,255,255,${b.a})`;
      g.shadowColor = 'rgba(120,140,170,.55)';
      g.shadowBlur = 3;
      g.fill();
    }
    if (chay) hen = requestAnimationFrame(ve);
  };

  document.addEventListener('visibilitychange', () => {
    chay = !document.hidden;
    cancelAnimationFrame(hen);
    if (chay) hen = requestAnimationFrame(ve);
  });
  addEventListener('resize', doiCo, { passive: true });
  doiCo();
  hen = requestAnimationFrame(ve);
})();
